import React from 'react';
import { TextField } from '@material-ui/core';
import trash from '../../images/icons/trash.svg';
import showAlert from '../../utils/alert';

const AdhocItemTable = ({
  ppeListFinal,
  crew,
  values,
  columns,
  itemOptions,
  setppeListFinal,
  hanldeDelete,
  setAdhocList
}) => {
  return (
    <table className="w-full ppe-table-rebuild">
      <thead>
        <tr>
          {columns.map((item) => (
            <th key={item} className="font-bold capitalize">{item}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {ppeListFinal?.length > 0 && ppeListFinal
          ?.filter((item) => item?.isAdhoc)
          ?.map((item, idx) => (
            <tr key={(item?.componentName) + (item?.measurement || idx)}>
              <td>
                <label title={item?.componentName}>{item?.componentName}</label>
              </td>
              {crew?.isShortClosed
              || crew?.invoiceStatus?.toLowerCase().includes('payment')
              || crew?.invoiceStatus?.toLowerCase().includes('voucher')
              || crew?.invoiceStatus?.toLowerCase().includes('transferred') ? (
                <>
                  <td>
                    <label>{item?.measurement}</label>
                  </td>
                  <td>
                    <label>{item?.quantity}</label>
                  </td>
                </>
              ) : (
                <>
                  <td>
                  {item?.measurement || ppeListFinal?.filter((val) => val?.isAdhoc).map((i, id) => {
    if (id === idx) {
      return i?.measurement;
    }
    return null;
  }).find(Boolean) ? (
                      <select
                        value={item?.measurement || ''}
                        onChange={(e) => {
                          const selectedMeasurement = e.target.value;
                          const newComponentName = item?.componentName;
                          const allItems = [...ppeListFinal];
                          const isDuplicate = allItems.some((val, id) => id !== idx
                          && val?.componentName === newComponentName
                          && val?.measurement === selectedMeasurement);
                          if (isDuplicate) {
                            showAlert('Same Item with this size already exists', 'error');
                            return;
                          }
                          const nonAdhocItem = values?.purchaseOrderCrew[0]?.ppeCategoryDetails
                          ?.filter((val) => !val?.isAdhoc);
                          const newPPEList = ppeListFinal
                          ?.filter((val) => val?.isAdhoc).map((i, id) => {
                            if (id === idx) {
                              return { ...i, measurement: e.target.value };
                            }
                            return i;
                          });
                          setppeListFinal([...nonAdhocItem, ...newPPEList]);
                          setAdhocList(newPPEList);
                        }}
                        className="w-full border-none rounded-md"
                      >
                        {itemOptions?.find((i) => i?.name === item?.componentName)
                        ?.measurement?.map((i) => (
                          <option key={i} value={i}>{i}</option>
                        ))}
                      </select>
                    ) : null}
                  </td>
                  <td>
                    <TextField
                      type="number"
                      value={item?.quantity || ''}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        const eToNumber = e.target.value === '' ? '' : Math.floor(Number(e.target.value));
                        const price = values?.currencyId === 1
                        ? item?.unitPrice : item?.unitPriceUsd;
                        const nonAdhocItem = values?.purchaseOrderCrew[0]?.ppeCategoryDetails
                          ?.filter((val) => !val?.isAdhoc);
                        const newPPEList = ppeListFinal
                        ?.filter((value) => value?.isAdhoc).map((i, ind) => {
                          if (ind === idx) {
                            return { ...i, quantity: eToNumber, totalPrice: eToNumber * price };
                          }
                          return i;
                        });
                        setppeListFinal([...nonAdhocItem, ...newPPEList]);
                        setAdhocList(newPPEList);
                      }}
                      className="w-full border-none rounded-md bg-white"
                      inputProps={{ min: 1 }}
                    />
                  </td>
                </>
              )}
              <td>
                {values?.currencyId === 1 ? (
                  <label>
                    {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPrice)}
                  </label>
                ) : (
                  <label>
                    {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.unitPriceUsd)}
                  </label>
                )}
              </td>
              <td>
                <label>
                  {(item?.quantity * (values?.currencyId === 1
                    ? item?.unitPrice : item?.unitPriceUsd)).toFixed(2)}
                </label>
              </td>
              <td className="ppe-table-action">
                <button
                type="button"
                onClick={hanldeDelete(item, idx)}
                  hidden={crew?.isShortClosed
                    || crew?.invoiceStatus?.toLowerCase().includes('payment')
                    || crew?.invoiceStatus?.toLowerCase().includes('voucher')
                    || crew?.invoiceStatus?.toLowerCase().includes('transferred')}
                >
                  <img src={trash} alt="DeleteIcon" title="Delete" className="action-icon w-6" />
                </button>
              </td>
            </tr>
          ))}
        {ppeListFinal?.length === 0 && (
          <tr>
            <td colSpan={6} className="text-left">No Data Available</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default AdhocItemTable;
